
import queryString from 'query-string';   // TODO refactorizar usando URLSearchParams para eliminar dependencia

import { evaluateQueryStringBooleanParameter } from '../helpers/utils';

const QueryKeys = {
  disableManualSeek: 'disableManualSeek',   // REVIEW specific
  startFromSecond: 'startFromSecond',       // TODO REVIEW playlist
  defaultLanguage: 'defaultLanguage',
  transcriptionUrl: 'transcriptionUrl',
  defaultHiddenChat: 'defaultHiddenChat',
  defaultShowingChat: 'defaultShowingChat',
  token: 'token',                           // TODO REVIEW
  // 'demo-backup': 'demo-backup',          // NOTE obsoleto
  // 'multi-channel': 'multi-channel',      // NOTE obsoleto
  lowLatency: 'lowLatency',                 // REVIEW specific
};

const QueryStrings = {

  overrideConfiguration: (configuration = {}, location) => {
    // console.log( 'controllers::QueryStrings::overrideConfiguration - configuration: ', configuration, ', location: ', location);    // DEBUG
    const { chatConfiguration, taggingConfiguration } = configuration;

    const queryParams = queryString.parse( location.search);
    if( configuration.PlayerComponent?.specificQueryStringsHandler) {
      configuration = configuration.PlayerComponent.specificQueryStringsHandler.overrideConfiguration( configuration, queryParams);
    }

    if( QueryKeys.defaultLanguage in queryParams) {
      taggingConfiguration.defaultLanguage = queryParams[ QueryKeys.defaultLanguage];
    }
    if( QueryKeys.transcriptionUrl in queryParams) {
      const label = taggingConfiguration.defaultLanguage ?? 'ES';
      taggingConfiguration.taggingList = [{ label, url: queryParams.transcriptionUrl }];
    }

    if( QueryKeys.defaultHiddenChat in queryParams) {
      chatConfiguration.defaultShowingChat = !evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.defaultHiddenChat]);
    }
    if( QueryKeys.defaultShowingChat in queryParams) {
      chatConfiguration.defaultShowingChat = evaluateQueryStringBooleanParameter( queryParams[ QueryKeys.defaultShowingChat]);
    }

    return configuration;
  },

};

export default QueryStrings;
